/**
 * History Import Log Service
 * API integration for the audit log of history imports (ASO/exames and trainings)
 */
import apiClient from './apiClient';

export type HistoryImportLogType = 'aso' | 'training';

export interface HistoryImportLogView {
  id: number;
  type: HistoryImportLogType;
  companyId: number;
  userId: number;
  userName: string;
  fileName: string;
  totalRows: number;
  imported: number;
  skipped: number;
  errorsCount: number;
  createdAt: string;
}

const extractData = <T>(response: { data?: { data?: T } | T }): T => {
  const body = response.data as { data?: T };
  return body?.data ?? (response.data as T);
};

class HistoryImportLogService {
  private baseUrl = '/history-import/logs';

  /**
   * Últimos logs de importação de histórico (ASO/exames e treinamentos)
   */
  async list(options?: { companyId?: number; limit?: number }): Promise<HistoryImportLogView[]> {
    const queryParams = new URLSearchParams();
    if (options?.companyId) {
      queryParams.append('companyId', String(options.companyId));
    }
    if (options?.limit) {
      queryParams.append('limit', String(options.limit));
    }
    const query = queryParams.toString();

    const response = await apiClient.get(`${this.baseUrl}${query ? `?${query}` : ''}`);

    return extractData(response);
  }
}

export const historyImportLogService = new HistoryImportLogService();
export default historyImportLogService;
